import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZPlayerSelectPrivate } from '../player/models';
import { ZPromoPrizeRewardSelect } from '../promo';

const c = initContract();
export const authReferralContract = c.router(
  {
    getInvitees: {
      method: 'GET',
      path: '/invitees',
      responses: {
        200: ZPlayerSelectPrivate.pick({
          id: true,
          firstName: true,
          avatarLocation: true,
        })
          .extend({
            isEligibleForRewards: z.boolean(),
            gracePeriodHoursRemaining: z.number().nullable(),
          })
          .array(),
        400: c.type<{ message: string }>(),
      },
    },
    getInviters: {
      method: 'GET',
      path: '/inviters',
      responses: {
        200: ZPlayerSelectPrivate.pick({
          id: true,
          firstName: true,
          avatarLocation: true,
        })
          .extend({
            isEligibleForRewards: z.boolean(),
            gracePeriodHoursRemaining: z.number().nullable(),
          })
          .array(),
        400: c.type<{ message: string }>(),
      },
    },
    getSharedWins: {
      method: 'GET',
      path: '/shared-wins',
      responses: {
        200: z.object({
          received: ZPromoPrizeRewardSelect.pick({
            createdAt: true,
            expiresAt: true,
            status: true,
          })
            .extend({
              createdAt: z.coerce.date(),
              promoPrizeRewardId: z.string(),
              promoPrizeOfferCode: z.string(),
              prizeSlug: z.string(),
              prizeTitle: z.string(),
              friendFirstName: z.string(),
              friendPrizeTierCode: z.string(),
            })
            .array(),
          sent: z
            .object({
              prizeWinId: z.string(),
              createdAt: z.coerce.date(),
              prizeTierCode: z.string(),
              friendFirstNames: z.string().array(),
              friendPromoPrizeOfferCode: z.string(),
              friendPrizeSlug: z.string(),
              friendPrizeTitle: z.string(),
            })
            .array(),
        }),
        400: c.type<{ message: string }>(),
      },
    },
    getSharedWinStats: {
      method: 'GET',
      path: '/shared-win-stats',
      responses: {
        200: z.object({
          received: z.number(),
          sent: z.number(),
        }),
        400: c.type<{ message: string }>(),
      },
    },
  },
  {
    pathPrefix: '/auth',
    commonResponses: {
      401: c.type<{ message: 'Unauthorized'; statusCode: 401 }>(),
    },
  },
);
